import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';
import { HighlightOffOutlined } from '@mui/icons-material';
import { PresetMediaItem } from 'src/pages/MachineGroupDetails/UpsertPresetForm';

interface RelatedPresetsDialogProps {
  isOpen: boolean;
  onClose: () => void;
  media: PresetMediaItem | null;
}

function RelatedPresetsDialog({
  isOpen,
  onClose,
  media,
}: RelatedPresetsDialogProps) {
  if (!media) return null;

  const { fileName } = media;

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontSize: '1.5rem', padding: '20px' }}>
        Media in Use: {fileName}
        <IconButton
          onClick={onClose}
          sx={{ position: 'absolute', right: 8, top: 8 }}
        >
          <HighlightOffOutlined fontSize="large" />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ padding: '20px 20px 0 20px' }}>
        <Typography variant="body1" sx={{ mb: 1 }}>
          This media file is currently being used by the following presets:
        </Typography>

        <List dense sx={{ listStyleType: 'disc', pl: 2 }}>
          {media.relatedPresets?.map((preset) => (
            <ListItem key={preset} sx={{ display: 'list-item', ml: 2 }}>
              <ListItemText primary={preset} />
            </ListItem>
          ))}
        </List>
      </DialogContent>

      <DialogActions sx={{ padding: '16px 24px' }}>
        <Button variant="outlined" onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default RelatedPresetsDialog;
